<template>
  <div class="Schedule">
    <ld-header
      v-if="index == 1"
      @click-right="$router.push({path: '/schedule/histroy', query: { index: 2 }})"
    >
      <template #left>
        <span class="font24 font-bold">日程</span>
      </template>
      <template #right>
        <span class="main-color">查看历史日程</span>
      </template>
    </ld-header>
    <ld-header v-else-if="index == 2">
      历史日程
    </ld-header>

    <div class="wrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <van-pull-refresh
          v-model="pullRefreshLoading"
          @refresh="onRefresh"
        >
          <van-list
            v-model="schedulePage.loading"
            :finished="schedulePage.finished"
            :error.sync="schedulePage.error"
            :error-text="schedulePage.errorText"
            @load="getScheduleList(schedulePage.pageNum++)"
          >
            <div
              v-for="(list, i) in scheduleGroupList"
              :key="i"
            >
              <h3 class="font22">
                {{ list[0].departDate }}
                <span class="font14 font-normal">({{ formatDate(list[0].departDate).week }})</span>
              </h3>

              <SchedulePanel
                v-for="(order, j) in list"
                :key="j"
                :data="order"
                :order-type="order.orderType"
                :find-scope="index"
                @to-order-detail="toOrderDetail"
                style="margin-top: 10px;"
              />
            </div>
            <van-empty v-show="scheduleList.length == 0" />
          </van-list>
        </van-pull-refresh>
      </mescroll-vue>
    </div>
  </div>
</template>

<script>
import { List, PullRefresh, Empty } from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'
import ldHeader from 'Common/ldHeader'
import SchedulePanel from './components/panel'
import { groupBy } from 'Utils/object'
import { formatDate } from '@/business/utils/dateUtil'
import Business from '@/business/utils/business'

export default {
  name: 'Schedule',
  components: {
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Empty.name]: Empty,
    ldHeader,
    MescrollVue,
    SchedulePanel
  },
  data () {
    return {
      index: 1,
      schedulePage: {
        pageNum: 0,
        count: 10,
        loading: false,
        finished: false,
        error: false,
        errorText: '请求失败，点击重新加载'
      },
      scheduleList: [],
      scheduleGroupList: [],
      pullRefreshLoading: false,
      down:{ use: false },
    }
  },
  created () {
    this.index = this.$route.query.index || 1
  },
  methods: {
    formatDate,
    onRefresh() {
      this.schedulePage.finished = false
      this.schedulePage.pageNum = 1
      this.getScheduleList()
      this.pullRefreshLoading = false
    },
    toOrderDetail(item, type) { // 跳转订单详情
      Business.toOrderDetail(item, type)
    },
    getScheduleList () {
      if (this.schedulePage.pageNum === 0) return

      this.schedulePage.loading = true
      let params = {
        findScope: this.index,
        pageNum: this.schedulePage.pageNum,
        count: this.schedulePage.count
      }

      // return
      this.$api['tkOrder/getScheduleOrder'](params).then(res => {
        this.schedulePage.loading = false
        if (res.data.list) {
          if (res.data.list.length < this.schedulePage.count) {
            this.schedulePage.finished = true
          }
          if (res.data.pageNum > 1) {
            this.scheduleList.push(...res.data.list)
          } else {
            this.scheduleList = res.data.list
          }
        } else {
          this.schedulePage.finished = true
        }

        // 把日期的 斜杠 替换成 -
        this.scheduleList.forEach(i => {
          if(i.departDate) i.departDate = i.departDate.replace(/\//g, '-')
        })

        this.scheduleGroupList = groupBy(this.scheduleList, i => i.departDate)
      }).catch(err => {
        this.schedulePage.error = true
        throw err
      })
    }
  }
}
</script>

<style lang="less" scoped>
.Schedule {
  .wrapper {
    height: calc(100vh - 97px);
    padding: 0 16px;
    overflow: hidden;
  }

}
</style>
